import React
    from "react";
import FormSubHeader
    from "./FormSubHeader";
import styled
    from "styled-components";

const FormHeaderLegend = styled.legend`
    font-size: 22px;
  border: 0;
  margin: 0 0 20px;
  padding: 0;
`

const FormHeader = ({
                        template,
                    }) => {
    const subheaders = [];

    Object.keys(template?.subheader).map(key => {
        subheaders.push(template?.subheader[key]);
    });

    return <div className="fz-form-field-group">
            <fieldset className='fz-form-fieldset fz-form-fieldset-header' id={template.id}>
                {template.content.value.length > 0 && <FormHeaderLegend className='fz-form-legend fz-form-header'>{template.content.value}</FormHeaderLegend>}

                {subheaders.length > 0 && subheaders.map((subheader, index) => {
                    return <FormSubHeader key={index} template={subheader}/>
                })}
            </fieldset>
        </div>
}

export default FormHeader;